module.exports = __webpack_public_path__ + "static/media/colorado-symph1.98317911.png";